module.exports = __webpack_public_path__ + "static/media/galeria1.c6638ff7.jpg";